import React from 'react';
export function HeroSection() {
  return <section className="relative w-full flex flex-col text-center px-4 py-8 sm:py-16 items-center justify-center pl-[20px] pr-[20px] pt-[20px] pb-[20px]" style={{
    background: 'linear-gradient(135deg, #0a0a0a 0%, #0a1510 30%, #0a100d 60%, #0a0a0a 100%)'
  }} data-id="element-132">
      {/* Logo */}
      <div className="mb-4" data-id="element-133">
        <span className="text-[#33BFA6] text-xl sm:text-2xl font-black tracking-widest" data-id="element-134">
          🌟 PROFEPACK
        </span>
      </div>

      {/* Main headline */}
      <h1 className="font-black text-white max-w-[320px] sm:max-w-2xl md:max-w-4xl lg:max-w-5xl sm:text-5xl md:text-7xl lg:text-8xl mb-[0px] text-[28px] leading-[1.1]" style={{
      textWrap: 'balance'
    } as React.CSSProperties} data-id="element-135">
        Todo tu año de Lengua y Literatura{' '}
        <span className="text-[#33BFA6]" data-id="element-136">resuelto.</span>
      </h1>

      {/* Mockup image — LCP element, priority load with explicit dimensions */}
      <div className="w-full max-w-[240px] sm:max-w-[300px] md:max-w-sm mx-auto mb-4" style={{
      aspectRatio: '1/1'
    }} data-id="element-137">
        <img src="https://cdn.magicpatterns.com/uploads/vr3KC8yiXatQjgH9shXDA9/Sin_titulo_(420_x_420_px)_(4).png" alt="PROFEPACK Megapack Lengua y Literatura — Combo Completo" className="w-full h-full object-contain" width={400} height={400} fetchPriority="high" data-id="element-138" />
      </div>

      {/* Subtitle */}
      <p className="text-[#33BFA6] text-lg sm:text-2xl font-bold max-w-3xl mb-[10px]" data-id="element-139">
        "Listo para usar. Sin buscar más."
      </p>

      {/* Body */}
      <p className="text-white sm:text-lg max-w-2xl mb-[2px] pt-[8px] pb-[8px] text-[16px]" data-id="element-140">
        El sistema que usan{' '}
        <strong data-id="element-141">+3.000 docentes de Lengua y Literatura</strong> de primaria y
        secundaria en Argentina para planificar todo el año en una tarde — sin
        improvisar, sin buscar y sin perder domingos.
      </p>

      {/* Pills */}
      <div className="flex flex-nowrap mb-[10px] gap-[5px] flex-row items-center justify-center" data-id="element-142">
        <span className="bg-black/50 border border-white/20 text-white text-[10px] sm:text-sm font-semibold px-2 sm:px-3 py-1 sm:py-1.5 rounded-full whitespace-nowrap" data-id="element-143">
          📄 100% PDF
        </span>
        <span className="bg-black/50 border border-white/20 text-white text-[10px] sm:text-sm font-semibold px-2 sm:px-3 py-1 sm:py-1.5 rounded-full whitespace-nowrap" data-id="element-144">
          ⚡ Acceso inmediato
        </span>
        <span className="bg-black/50 border border-white/20 text-white text-[10px] sm:text-sm font-semibold px-2 sm:px-3 py-1 sm:py-1.5 rounded-full whitespace-nowrap" data-id="element-145">
          🇦🇷 Currículo argentino
        </span>
      </div>

      {/* CTA Button */}
      <a href="#pricing" className="btn-bordo-pulse bg-[#33BFA6] text-gray-900 font-black text-base sm:text-2xl px-6 sm:px-10 py-4 sm:py-5 rounded-xl hover:bg-[#2AA890] transition-colors inline-block mb-5 w-full sm:w-auto max-w-sm" data-id="element-146">
        🌟 → QUIERO MI PROFEPACK AHORA
      </a>

      {/* Trust badges */}
      <p className="text-gray-300 text-xs sm:text-sm flex flex-wrap items-center justify-center gap-2 sm:gap-3" data-id="element-147">
        <span data-id="element-148">🛡️ Garantía 7 días sin preguntas</span>
        <span data-id="element-149">🔒 Pago 100% seguro</span>
        <span data-id="element-150">💳 Mercado Pago</span>
      </p>
    </section>;
}